// import React, { Fragment } from "react";
// import PropTypes from "prop-types";
// import {
//   useTable,
//   useGlobalFilter,
//   useSortBy,
//   useFilters,
//   useExpanded,
//   usePagination,
// } from "react-table";
// import { Table, Row, Col, Button } from "react-bootstrap";
// import { DefaultColumnFilter } from "./Filter";

// import { ProductsGlobalFilter } from "./GlobalSearchFilter";

// interface GlobalFilterProps {
//   preGlobalFilteredRows?: any;
//   globalFilter?: any;
//   setGlobalFilter?: any;
//   SearchPlaceholder?: string;
//   isProductsFilter?: boolean;
// }

// // Define a default UI for filtering
// function GlobalFilter({
//   preGlobalFilteredRows,
//   globalFilter,
//   setGlobalFilter,
//   SearchPlaceholder,
//   isProductsFilter,
// }: GlobalFilterProps) {
//   const [value, setValue] = React.useState(globalFilter);
//   const onChange = (value: any) => {
//     setGlobalFilter(value || undefined);
//   };

//   return (
//     <React.Fragment>
//       {isProductsFilter && <ProductsGlobalFilter />}
//       <Col className="col-sm">
//         {/* <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block"> */}
//         <div className="d-flex justify-content-sm-end">
//           <label htmlFor="search-bar-0" className="search-label">
//             {/* <span id="search-bar-0-label" className="sr-only">
//                 Search this table
//               </span> */}
//             <input
//               onChange={(e) => {
//                 setValue(e.target.value);
//                 onChange(e.target.value);
//               }}
//               id="search-bar-0"
//               type="text"
//               className="form-control"
//               placeholder={SearchPlaceholder}
//               value={value || ""}
//             />
//           </label>
//           <i className="bx bx-search-alt search-icon"></i>
//         </div>
//         {/* </div> */}
//       </Col>
//     </React.Fragment>
//   );
// }

// interface TableContainerProps {
//   columns?: any;
//   data?: any;
//   isGlobalFilter?: any;
//   isAddOptions?: any;
//   divClassName?: any;
//   theadClassName?: any;
//   tableClass?: any;
//   theadClass?: any;
//   isBordered?: boolean;
//   isAddUserList?: any;
//   handleOrderClicks?: any;
//   handleUserClick?: any;
//   handleCustomerClick?: any;
//   isAddCustList?: any;
//   customPageSize?: any;
//   className?: any;
//   customPageSizeOptions?: any;
//   iscustomPageSize?: boolean;
//   SearchPlaceholder: string;
//   isProductsFilter?: boolean;
//   manualPagination?: boolean;
//   pageCount?: number;
//   currentPage?: number;
//   onPageChange?: (page: number) => void;
//   onPageSizeChange?: (size: number) => void;
// }

// const TableContainer = ({
//   columns,
//   data,
//   tableClass,
//   theadClass,
//   isBordered,
//   isGlobalFilter,
//   isProductsFilter,
//   isAddOptions,
//   isAddUserList,
//   handleOrderClicks,
//   handleUserClick,
//   handleCustomerClick,
//   isAddCustList,
//   customPageSize,
//   iscustomPageSize,
//   customPageSizeOptions,

//   SearchPlaceholder,

//   // Add these props:
//   manualPagination,
//   pageCount,
//   currentPage,
//   onPageChange,
//   onPageSizeChange,
// }: TableContainerProps) => {
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     prepareRow,
//     canPreviousPage,
//     canNextPage,
//     pageOptions,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     state,
//     preGlobalFilteredRows,
//     setGlobalFilter,
//     state: { pageIndex, pageSize },
//   } = useTable(
//     {
//       columns,
//       data,
//       manualPagination: manualPagination || false, // enable manual pagination mode
//       pageCount: pageCount,
//       initialState: {
//         pageIndex: currentPage || 0,
//         pageSize: customPageSize,
//       },
//     },
//     useGlobalFilter,
//     useFilters,
//     useSortBy,
//     useExpanded,
//     usePagination
//   );

//   const generateSortingIndicator = (column: any) => {
//     return column.isSorted ? (
//       column.isSortedDesc ? (
//         <span>&#9650;</span>
//       ) : (
//         <span>&#9660;</span>
//       )
//     ) : (
//       ""
//     );
//   };

//   const onChangeInSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
//     const size = Number(event.target.value);
//     if (onPageSizeChange) onPageSizeChange(size);
//   };

//   const onPageClick = (page: number) => {
//     if (onPageChange) onPageChange(page);
//   };

//   return (
//     <Fragment>
//       {iscustomPageSize && (
//         <Col md={customPageSizeOptions ? 2 : 1}>
//           <select
//             className="form-select"
//             value={pageSize}
//             onChange={onChangeInSelect}
//           >
//             {[10, 20, 30, 40, 50].map((pageSize) => (
//               <option key={pageSize} value={pageSize}>
//                 Show {pageSize}
//               </option>
//             ))}
//           </select>
//         </Col>
//       )}
//       {isGlobalFilter && (
//         <GlobalFilter
//           preGlobalFilteredRows={preGlobalFilteredRows}
//           globalFilter={state.globalFilter}
//           setGlobalFilter={setGlobalFilter}
//           SearchPlaceholder={SearchPlaceholder}
//           isProductsFilter={isProductsFilter}
//         />
//       )}
//       {isAddOptions && (
//         <Col sm="7">
//           <div className="text-sm-end">
//             <Button
//               type="button"
//               variant="success"
//               className="btn-rounded mb-2 me-2"
//               onClick={handleOrderClicks}
//             >
//               <i className="mdi mdi-plus me-1" />
//               Add New Order
//             </Button>
//           </div>
//         </Col>
//       )}
//       {isAddUserList && (
//         <Col sm="7">
//           <div className="text-sm-end">
//             <Button
//               type="button"
//               variant="primary"
//               className="btn mb-2 me-2"
//               onClick={handleUserClick}
//             >
//               <i className="mdi mdi-plus-circle-outline me-1" />
//               Create New User
//             </Button>
//           </div>
//         </Col>
//       )}
//       {isAddCustList && (
//         <Col sm="7">
//           <div className="text-sm-end">
//             <Button
//               type="button"
//               variant="success"
//               className="btn-rounded mb-2 me-2"
//               onClick={handleCustomerClick}
//             >
//               <i className="mdi mdi-plus me-1" />
//               Customers
//             </Button>
//           </div>
//         </Col>
//       )}

//       <div className="table-responsive react-table">
//         <Table
//           hover
//           {...getTableProps()}
//           className={tableClass}
//           bordered={isBordered}
//         >
//           <thead className={theadClass}>
//             {headerGroups.map((headerGroup: any) => (
//               <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((columns: any) => (
//                   <th key={columns.id}>
//                     <div className="" {...columns.getSortByToggleProps()}>
//                       {columns.render("Header")}
//                       {generateSortingIndicator(columns)}
//                     </div>
//                     {/* <Filter column={columns} /> */}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>

//           <tbody {...getTableBodyProps()}>
//             {page.map((row: any) => {
//               prepareRow(row);
//               return (
//                 <Fragment key={row.getRowProps().key}>
//                   <tr>
//                     {row.cells.map((cell: any) => {
//                       return (
//                         <td key={cell.id} {...cell.getCellProps()}>
//                           {cell.render("Cell")}
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 </Fragment>
//               );
//             })}
//           </tbody>
//         </Table>
//       </div>
//       <Row className="align-items-center mt-2 py-2 px-2 gy-2 text-center text-sm-start">
//         <div className="col-sm">
//           <div className="text-muted">
//             Showing <span className="fw-semibold">{pageIndex + 1}</span> of{" "}
//             <span className="fw-semibold">{pageCount}</span> Pages
//           </div>
//         </div>
//         <div className="col-sm-auto">
//           <ul className="pagination pagination-separated mb-0 justify-content-center justify-content-sm-start">
//             <li
//               className={!canPreviousPage ? "page-item disabled" : "page-item"}
//               onClick={() => onPageClick && onPageClick((currentPage ?? 0) - 1)}
//             >
//               <Button variant="link" className="page-link">
//                 Previous
//               </Button>
//             </li>

//             {Array.from({ length: pageCount || 0 }, (_, i) => (
//               <li
//                 key={i}
//                 className={currentPage === i ? "page-item active" : "page-item"}
//                 onClick={() => onPageClick && onPageClick(i)}
//               >
//                 <Button variant="link" className="page-link">
//                   {i + 1}
//                 </Button>
//               </li>
//             ))}

//             <li
//               className={!canNextPage ? "page-item disabled" : "page-item"}
//               onClick={() => onPageClick && onPageClick((currentPage ?? 0) + 1)}
//             >
//               <Button variant="link" className="page-link">
//                 Next
//               </Button>
//             </li>
//           </ul>
//         </div>
//       </Row>
//     </Fragment>
//   );
// };

// TableContainer.propTypes = {
//   preGlobalFilteredRows: PropTypes.any,
// };

// export default TableContainer;

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button } from "react-bootstrap";
import { DefaultColumnFilter } from "./Filter";
import { ProductsGlobalFilter } from "./GlobalSearchFilter";

interface GlobalFilterProps {
  preGlobalFilteredRows?: any;
  globalFilter?: any;
  setGlobalFilter?: any;
  SearchPlaceholder?: string;
  isProductsFilter?: boolean;
}

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  SearchPlaceholder,
  isProductsFilter,
}: GlobalFilterProps) {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = (value: any) => {
    setGlobalFilter(value || undefined);
  };

  return (
    <React.Fragment>
      {isProductsFilter && <ProductsGlobalFilter />}
      <Col className="col-sm">
        <div className="d-flex justify-content-sm-end">
          <label htmlFor="search-bar-0" className="search-label">
            <input
              onChange={(e) => {
                setValue(e.target.value);
                onChange(e.target.value);
              }}
              id="search-bar-0"
              type="text"
              className="form-control"
              placeholder={SearchPlaceholder}
              value={value || ""}
            />
          </label>
          <i className="bx bx-search-alt search-icon"></i>
        </div>
      </Col>
    </React.Fragment>
  );
}

interface TableContainerProps {
  columns?: any;
  data?: any;
  isGlobalFilter?: any;
  isAddOptions?: any;
  divClassName?: any;
  theadClassName?: any;
  tableClass?: any;
  theadClass?: any;
  isBordered?: boolean;
  isAddUserList?: any;
  handleOrderClicks?: any;
  handleUserClick?: any;
  handleCustomerClick?: any;
  isAddCustList?: any;
  customPageSize?: any;
  className?: any;
  customPageSizeOptions?: any;
  iscustomPageSize?: boolean;
  SearchPlaceholder: string;
  isProductsFilter?: boolean;
  manualPagination?: boolean;
  pageCount?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  isFilterable?: boolean;
}

const TableContainer = ({
  columns,
  data,
  tableClass,
  theadClass,
  isBordered,
  isGlobalFilter,
  isProductsFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  iscustomPageSize,
  customPageSizeOptions,
  SearchPlaceholder,
  manualPagination,
  pageCount,
  currentPage,
  onPageChange,
  onPageSizeChange,
}: TableContainerProps) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      manualPagination: manualPagination || false,
      pageCount: pageCount,
      initialState: {
        pageIndex: currentPage || 0,
        pageSize: customPageSize,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const generateSortingIndicator = (column: any) => {
    return column.isSorted ? (
      column.isSortedDesc ? (
        <span>&#9650;</span>
      ) : (
        <span>&#9660;</span>
      )
    ) : (
      ""
    );
  };

  const onChangeInSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const size = Number(event.target.value);
    if (onPageSizeChange) onPageSizeChange(size);
  };

  // Fixed pagination handlers with proper bounds checking
  const handlePreviousPage = () => {
    if (manualPagination && onPageChange) {
      const newPage = Math.max(0, pageIndex - 1);
      if (newPage >= 0) {
        onPageChange(newPage);
      }
    } else if (canPreviousPage) {
      previousPage();
    }
  };

  const handleNextPage = () => {
    if (manualPagination && onPageChange) {
      const newPage = Math.min((pageCount || 1) - 1, pageIndex + 1);
      if (newPage < (pageCount || 1)) {
        onPageChange(newPage);
      }
    } else if (canNextPage) {
      nextPage();
    }
  };

  const handlePageClick = (page: number) => {
    if (manualPagination && onPageChange) {
      if (page >= 0 && page < (pageCount || 1)) {
        onPageChange(page);
      }
    } else {
      gotoPage(page);
    }
  };

  // Calculate pagination state for manual pagination
  const effectivePageIndex = manualPagination ? currentPage || 0 : pageIndex;
  const effectivePageCount = manualPagination
    ? pageCount || 0
    : pageOptions.length;
  const effectiveCanPreviousPage = manualPagination
    ? effectivePageIndex > 0
    : canPreviousPage;
  const effectiveCanNextPage = manualPagination
    ? effectivePageIndex < effectivePageCount - 1
    : canNextPage;

  return (
    <Fragment>
      {/* {iscustomPageSize && (
        <Col md={customPageSizeOptions ? 2 : 1}>
          <select
            className="form-select"
            value={pageSize}
            onChange={onChangeInSelect}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
      )} */}
      {isGlobalFilter && (
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={state.globalFilter}
          setGlobalFilter={setGlobalFilter}
          SearchPlaceholder={SearchPlaceholder}
          isProductsFilter={isProductsFilter}
        />
      )}
      {isAddOptions && (
        <Col sm="7">
          <div className="text-sm-end">
            <Button
              type="button"
              variant="success"
              className="btn-rounded mb-2 me-2"
              onClick={handleOrderClicks}
            >
              <i className="mdi mdi-plus me-1" />
              Add New Order
            </Button>
          </div>
        </Col>
      )}
      {isAddUserList && (
        <Col sm="7">
          <div className="text-sm-end">
            <Button
              type="button"
              variant="primary"
              className="btn mb-2 me-2"
              onClick={handleUserClick}
            >
              <i className="mdi mdi-plus-circle-outline me-1" />
              Create New User
            </Button>
          </div>
        </Col>
      )}
      {isAddCustList && (
        <Col sm="7">
          <div className="text-sm-end">
            <Button
              type="button"
              variant="success"
              className="btn-rounded mb-2 me-2"
              onClick={handleCustomerClick}
            >
              <i className="mdi mdi-plus me-1" />
              Customers
            </Button>
          </div>
        </Col>
      )}

      <div className="table-responsive react-table">
        <Table
          hover
          {...getTableProps()}
          className={tableClass}
          bordered={isBordered}
        >
          <thead className={theadClass}>
            {headerGroups.map((headerGroup: any) => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((columns: any) => (
                  <th key={columns.id}>
                    <div className="" {...columns.getSortByToggleProps()}>
                      {columns.render("Header")}
                      {generateSortingIndicator(columns)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row: any) => {
              prepareRow(row);
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map((cell: any) => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>
      <Row className="align-items-center mt-2 py-2 px-2 gy-2 text-center text-sm-start">
        <div className="col-sm">
          <div className="text-muted">
            Showing{" "}
            <span className="fw-semibold">
              {effectivePageIndex * pageSize + 1} to{" "}
              {Math.min((effectivePageIndex + 1) * pageSize, data.length)}
            </span>{" "}
            of <span className="fw-semibold">{data.length}</span> entries
          </div>
        </div>
        <div className="col-sm-auto">
          <ul className="pagination pagination-separated mb-0 justify-content-center justify-content-sm-start">
            <li
              className={
                !effectiveCanPreviousPage ? "page-item disabled" : "page-item"
              }
              onClick={handlePreviousPage}
              style={{
                cursor: effectiveCanPreviousPage ? "pointer" : "default",
              }}
            >
              <Button
                variant="link"
                className="page-link"
                disabled={!effectiveCanPreviousPage}
              >
                Previous
              </Button>
            </li>

            {/* Smart pagination rendering - show limited pages with ellipsis */}
            {(() => {
              const pages = [];
              const pageNeighbours = 2; // Number of pages to show on each side of current page
              const totalPages = effectivePageCount;
              const currentPage = effectivePageIndex;

              // Always show first page
              if (currentPage > pageNeighbours + 1) {
                pages.push(
                  <li
                    key={0}
                    className={
                      currentPage === 0 ? "page-item active" : "page-item"
                    }
                    onClick={() => handlePageClick(0)}
                    style={{ cursor: "pointer" }}
                  >
                    <Button variant="link" className="page-link">
                      1
                    </Button>
                  </li>
                );
                if (currentPage > pageNeighbours + 2) {
                  pages.push(
                    <li key="ellipsis-start" className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }
              }

              // Show pages around current page
              const startPage = Math.max(0, currentPage - pageNeighbours);
              const endPage = Math.min(
                totalPages - 1,
                currentPage + pageNeighbours
              );

              for (let i = startPage; i <= endPage; i++) {
                pages.push(
                  <li
                    key={i}
                    className={
                      currentPage === i ? "page-item active" : "page-item"
                    }
                    onClick={() => handlePageClick(i)}
                    style={{ cursor: "pointer" }}
                  >
                    <Button variant="link" className="page-link">
                      {i + 1}
                    </Button>
                  </li>
                );
              }

              // Always show last page
              if (currentPage < totalPages - pageNeighbours - 1) {
                if (currentPage < totalPages - pageNeighbours - 2) {
                  pages.push(
                    <li key="ellipsis-end" className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }
                pages.push(
                  <li
                    key={totalPages - 1}
                    className={
                      currentPage === totalPages - 1
                        ? "page-item active"
                        : "page-item"
                    }
                    onClick={() => handlePageClick(totalPages - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <Button variant="link" className="page-link">
                      {totalPages}
                    </Button>
                  </li>
                );
              }

              return pages;
            })()}

            <li
              className={
                !effectiveCanNextPage ? "page-item disabled" : "page-item"
              }
              onClick={handleNextPage}
              style={{ cursor: effectiveCanNextPage ? "pointer" : "default" }}
            >
              <Button
                variant="link"
                className="page-link"
                disabled={!effectiveCanNextPage}
              >
                Next
              </Button>
            </li>
          </ul>
        </div>
      </Row>
    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
